import { render, staticRenderFns } from "./doc_show_sales_invoice.vue?vue&type=template&id=641aef22&"
import script from "./doc_show_sales_invoice.vue?vue&type=script&lang=js&"
export * from "./doc_show_sales_invoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports